const FileDownloadIcon = ({ size = 19, fill = '#036EBC' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 9H12.25L9.25 12L6.25 9H8.5V6H10V9ZM11.5 3H4V15H14.5V6H11.5V3ZM2.5 2.24385C2.5 1.83304 2.83562 1.5 3.24888 1.5H12.25L15.9998 5.25L16 15.7444C16 16.1617 15.6663 16.5 15.2549 16.5H3.24505C2.83357 16.5 2.5 16.1585 2.5 15.7561V2.24385Z"
        fill={fill}
      />
    </svg>
  );
};

export default FileDownloadIcon;
